/**
 * Edit from: https://github.com/ant-design/ant-design/blob/master/components/config-provider/UnstableContext.tsx
 */
import * as React from 'react';
import { render, unmount } from 'rc-util/lib/React/render';
const defaultReactRender = (node, container) => {
    // TODO: 暂时这么手动兼容 react19，以后再看怎么处理
    // Warning for React 19
    if (process.env.NODE_ENV !== 'production') {
        const majorVersion = parseInt(React.version.split('.')[0], 10);
        if (majorVersion >= 19) {
            console.warn('React@19 需要配置 unstableSetRender，请查看 README.md');
        }
    }
    render(node, container);
    return () => {
        return unmount(container);
    };
};
let unstableRender = defaultReactRender;
/**
 * 为 react19 设置兼容的 render 方法
 * @deprecated
 *   - 仅用于 react19
 *   - 会在以后的版本中移除
 *   - 使用方式见 `README.md`
 * @export
 * @param {TRenderType} [render]
 * @return {*}
 */
export function unstableSetRender(render) {
    if (render) {
        unstableRender = render;
    }
    return unstableRender;
}
